export class AppsCondition {
    'operator';
    'apps';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ListOperators",
            "format": ""
        },
        {
            "name": "apps",
            "baseName": "apps",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AppsCondition.attributeTypeMap;
    }
    constructor() {
    }
}
